import React, { useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import HPOTree from "../atoms/HPOTree";
import HPOSelector from "./HPOSelector";
import PubmedEntry from "./PubmedEntry";
import HelperText from "../atoms/HelperText";
import countPhenos from "../../common/helpers/getTotalDiseasesAndPhenotypes";
import { PHENOTYPES_DATABASES } from "../atoms/GermlineModeForm/constants";

function PhenotypeScreen({ entry, onEntryUpdated }) {
  const hpoLimit = 100;
  const conf = {};
  const [source, setSource] = useState(PHENOTYPES_DATABASES[0].value);

  const hpoCount = useMemo(() => {
    return countPhenos(entry);
  }, [entry]);

  const addItem = useCallback(
    (x) => {
      const item = { ...x, ...conf, expanded: true, checked: true };
      const updated = x.disease_name
        ? entry.addDisease(item).clone()
        : entry.addPhenotype(item).clone();

      onEntryUpdated(updated);
    },
    [entry]
  );

  return (
    <>
      <div className="tw-font-bold text-larger-3">3. Phenotypes</div>
      <div>Please add any phenotypes this variant is linked to.</div>
      <div>
        Adding the phenotype(s) will make your contribution more useful for the
        community.
      </div>

      <div className="tw-flex tw-items-center tw-mt-2 tw-mb-3">
        <div>
          Phenotype names from:{" "}
          <HelperText customText="Get phenotype names from all sources or from OMIM only" />
        </div>
        <div onChange={(ev) => setSource(ev.target.value)}>
          {PHENOTYPES_DATABASES.map((x) => (
            <label key={x.value} className="no-margin tw-margin-0 tw-px-2">
              <input
                type="radio"
                value={x.value}
                name="phenotypeSource"
                defaultChecked={x.checked}
              />
              <span className="tw-px-1">{x.name}</span>
            </label>
          ))}
        </div>
      </div>
      <div className="tw-flex tw-items-center">
        <div className="tw-flex-grow tw-max-w-screen-sm">
          <HPOSelector hpo={entry} addItem={addItem} source={source} />
        </div>
      </div>

      {hpoCount > hpoLimit ? (
        <div className="tw-bg-red-300 tw-text-white tw-text-center tw-py-4">
          You can select up to 100 diseases or phenotypes.
        </div>
      ) : null}

      {hpoCount > 0 ? <div className="tw-h-3" /> : null}

      <HPOTree
        updateNumberOfSelections={() => onEntryUpdated(entry.clone())}
        checkBoxes={true}
        HPOTree={{ hpo: [entry] }}
      />
    </>
  );
}

PhenotypeScreen.propTypes = {
  entry: PropTypes.instanceOf(PubmedEntry).isRequired,
  onEntryUpdated: PropTypes.func.isRequired,
};

PhenotypeScreen.defaultProps = {};

export default PhenotypeScreen;
